import {createCognitoUser} from './createCognitoUser';
import {SchoolService, DiscountCodeService} from '../../modules';
import {UserService} from '../../modules/User';
import {parsePhoneNumberFromString} from 'libphonenumber-js';
import {StudentsService} from '../../modules';
import moment from 'moment';
import * as XLSX from 'xlsx';
import {saveAs} from 'file-saver';

export const exportNewDataToExcel = (newData, filename = 'failedData.xlsx') => {
  const wb = XLSX.utils.book_new();

  Object.keys(newData).forEach((key) => {
    if (Array.isArray(newData[key])) {
      const ws = XLSX.utils.json_to_sheet(newData[key]);
      XLSX.utils.book_append_sheet(wb, ws, key);
    }
  });

  const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
  const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
  saveAs(blob, filename);
};

const schoolService = new SchoolService();
const userService = new UserService();
const discountCodeService = new DiscountCodeService();
const studentsService = new StudentsService();
let newData = {};
function normalizeGender(input) {
  if (!input) return 'MAIL'; // default fallback

  const clean = input.trim().toLowerCase();

  // Check by first letter only
  if (clean.startsWith('f')) return 'FEMAIL';
  if (clean.startsWith('m')) return 'MAIL';

  // If it's totally wrong, fallback
  return 'MAIL';
}
export const createSchoolScript = async (data) => {
  try {
    let school = data.SCHOOL[0];
    let teachers = data.TEACHERS;
    let classes = data.CLASSSCHOOL;
    let students = data.STUDENTS;
    debugger;
    // Keep newData always populated with current working references
    newData = JSON.parse(
      JSON.stringify({
        SCHOOLS: [school],
        TEACHERS: teachers,
        CLASSSCHOOL: classes,
        STUDENTS: students,
      }),
    );

    let schoolId;

    if (school.isCreated === true) {
      schoolId = school.schoolId;
    } else {
      console.log('Ill create cognito');
      const phoneVaildatio = parsePhoneNumberFromString(school.phoneNumber);
      let schoolCognitoUserId = userService.adminCreateCognitoUser(
        school.email.trim(),
      );
      // await createCognitoUser(
      //   school.email.trim(),
      //   phoneVaildatio.isValid ? school.phoneNumber.trim() : '+966000000000',
      //   'SCHOOL',
      // );
      console.log('schoolCognitoUserId:', schoolCognitoUserId);
      let schoolUserId = userService.createUser(
        schoolCognitoUserId,
        'SA',
        'Asia/riyadh',
      );
      const input = {
        userId: schoolUserId,
        nameArabic: school.nameArabic,
        name: school.name,
        isActive: true,
      };
      console.log('schoolUserId:', schoolUserId);
      schoolId = await schoolService.createSchool(input);
      console.log('schoolId:', schoolId);
      school['schoolId'] = schoolId;
      school.isCreated = true;
      // Keep newData up-to-date after setting school
      newData['SCHOOLS'] = [school];
    }
    for (let i = 0; i < teachers.length; i++) {
      const teacher = teachers[i];
      console.log('inside teacher,', i);

      // Wait for 1 second before processing the next teacher
      await new Promise((resolve) => setTimeout(resolve, 100));

      if (teacher.tempId === null) {
        continue;
      }

      let teacherId;
      if (teacher.isCreated === true) {
        teacherId = teacher.teacherId;
      } else {
        console.log('inside teacher create:', i);
        const phoneVaildatio = parsePhoneNumberFromString(
          teacher.phoneNumber.trim(),
        );
        const teacherCognitoUserId = await createCognitoUser(
          teacher.email.trim(),
          phoneVaildatio.isValid ? teacher.phoneNumber.trim() : '+966000000000',
          'TEACHER',
        );
        console.log('teacherCognitoUserId:', teacherCognitoUserId);
        const teacherUserId = await userService.createUser(
          teacherCognitoUserId,
          phoneVaildatio.isValid ? phoneVaildatio.country : 'SA',
          'Asia/riyadh',
        );
        console.log('teacherUserId:', teacherUserId);
        teacherId = await schoolService.createTeacher(
          teacherUserId,
          teacher.email,
          teacher.name,
          teacher.phoneNumber,
          schoolId,
        );
        console.log('teacherId:', teacherId);
      }

      teachers[i]['teacherId'] = teacherId;
      teachers[i].isCreated = true;
      // Keep newData up-to-date after each teacher
      newData['TEACHERS'] = teachers;
    }

    for (let i = 0; i < classes.length; i++) {
      const classSchool = classes[i];
      if (classSchool.tempId === null) {
        continue;
      }
      let classId;
      if (classSchool.isCreated === true) {
        classId = classSchool.classId;
      } else {
        const teacherOfTheClass = teachers.find(
          (teacher) => teacher.tempId === classSchool.teacherId,
        );
        console.log('teacherOfTheClass:', teacherOfTheClass);
        if (teacherOfTheClass) {
          classId = await schoolService.createClassSchool(
            schoolId,
            teacherOfTheClass.teacherId,
            classSchool.levelId,
            classSchool.name,
            classSchool.schoolId,
          );
        } else {
          throw new Error(
            `Teacher with tempId ${classSchool.teacherId} is not found`,
          );
        }

        console.log('classId:', classId);
      }
      let discountCodeId;
      if (
        classSchool.isCreated === true &&
        classSchool.discountCodeId !== null
      ) {
        discountCodeId = classSchool.discountCodeId;
      } else {
        console.log('ill create discount YA ABLA');
        discountCodeId = discountCodeService.createDiscountCodes(
          schoolId,
          classId,
          classSchool.levelId,
          classSchool.curriculumId,
          classSchool.packageId,
          1,
          100,
          moment.utc(new Date()).toISOString(),
          moment.utc().add(1, 'months').toISOString(),
          'MULTI',
        );
      }

      classes[i]['classId'] = classId;
      classes[i]['discountCodeId'] = discountCodeId;
      classes[i].isCreated = true;
      // Keep newData up-to-date after each class
      newData['CLASSSCHOOL'] = classes;

      // Wait for 1 second before processing the next class
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
    newData['SCHOOLS'] = [school];
    newData['TEACHERS'] = teachers;
    newData['CLASSSCHOOL'] = classes;
    // fs.writeFileSync(withoutStudentsPath, JSON.stringify(newData, null, 2));
    await new Promise((resolve) => setTimeout(resolve, 100));

    for (let i = 0; i < students.length; i++) {
      const student = students[i];

      let studentId;
      if (student.isCreated === true) {
        studentId = student.studentId;
      } else {
        const phoneVaildatio = parsePhoneNumberFromString(
          student.phoneNumber.trim(),
        );
        const studentCognitoUser = await createCognitoUser(
          student.email.trim(),
          phoneVaildatio.isValid ? student.phoneNumber.trim() : '+966000000000',
          null,
          student.password,
        );
        const studentCognitoUserId =
          studentCognitoUser?.cognitoUserId ?? studentCognitoUser;

        if (studentCognitoUser && studentCognitoUser.email) {
          students[i].email = studentCognitoUser.email;
        }

        if (studentCognitoUser && studentCognitoUser.password) {
          students[i].password = studentCognitoUser.password;
        }

        console.log('studentCognitoUserId:', studentCognitoUserId);
        const studentUserId = await userService.createUser(
          studentCognitoUserId,
          phoneVaildatio.isValid ? phoneVaildatio.country : 'SA',
          'Asia/riyadh',
        );
        console.log('studentUserId:', studentUserId);
        const classOfTheStudent = classes.find(
          (classSchool) => classSchool.tempId === student.classschoolId,
        );
        if (classOfTheStudent?.classId) {
          studentId = await studentsService.createStudent(
            studentUserId,
            student.name,
            moment(student.birthDate).format('YYYY-MM-DD'),
            student.age,
            normalizeGender(student.gender.trim()),
            schoolId,
            true,
            classOfTheStudent.classId,
          );
          console.log('studentId:', studentId);
        } else {
          throw new Error(
            `Class with tempId ${student.classschoolId} is not found`,
          );
        }
      }
      students[i]['studentId'] = studentId;
      students[i].isCreated = true;
      // Keep newData up-to-date after each student
      newData['STUDENTS'] = students;

      // Wait for 1 second before processing the next student
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
    for (let i = 0; i < classes.length; i++) {
      const classSchool = classes[i];
      console.log('inside class disc,', i, classSchool);
      if (classSchool.tempId === null) {
        continue;
      }
      const applyingCodeResponse = await discountCodeService.applyDiscountCode(
        classSchool.classId,
        classSchool.discountCodeId,
        classSchool.packageId,
      );
      console.log('applyingCodeResponse:', applyingCodeResponse);
      // Wait for 1 second before processing the next class
      await new Promise((resolve) => setTimeout(resolve, 200));
    }
    newData['SCHOOLS'] = [school];
    newData['TEACHERS'] = teachers;
    newData['CLASSSCHOOL'] = classes;
    newData['STUDENTS'] = students;
  } catch (err) {
    console.error('startCreation failed:', err);
    try {
      //  exportNewDataToExcel(newData, 'failedData.xlsx');
    } catch (inner) {
      console.error('Failed to write failed.json or Excel:', inner);
    }
    throw err;
  }
};
